import type {
  AcceptanceSerializedType,
  BaseDocumentContentType,
  UserSerializedType,
} from 'sweet-types';

export type VersionContentType = AcceptanceSerializedType['content_type'];
export type DocumentVersionContentType = VersionContentType;

export type DocumentContentType = BaseDocumentContentType;

export type AcceptanceStatusType = {
  id: number;
  status: boolean | null;
  url: string;
  user: UserSerializedType;
  created_at: string;
  modified_at: string;
  accepted_at: null | string;
  rejected_at: null | string;
  seen_at: null | string;
};
export type AcceptanceType = {
  id: number;
  url: string;
  object_id: number;
  content_type: VersionContentType;
  accept_statuses: Array<AcceptanceStatusType>;
  message: string;
  requester: UserSerializedType | null;
  created_at: string;
  modified_at: string;
};
export type GenericAcceptableDocument = {
  readonly id: number;
  readonly html_url: string;
  readonly content_type: BaseDocumentContentType;
  readonly current_version: {
    readonly id: number;
    readonly url: string;
    readonly html_url: string;
  };
  readonly approved_at: null | string;
};

export const translateCommentContentType = (
  contentType: VersionContentType
): BaseDocumentContentType => {
  const data: Record<string, BaseDocumentContentType> = {
    procedureversion: 'procedure',
    policyversion: 'policy',
    processversion: 'proceduregroup',
  };
  return data[contentType];
};
